module.exports = __webpack_public_path__ + "img/product_4.59c04c9.jpg";